module.exports = __webpack_public_path__ + "static/sales-report-80db469c83f641adbd4c2904b38c7eae.png";